export interface ILead {
  id?: string;
  page?: string;
  dataLayerName?: string;

  journeyName?: string;
  firstNameApplicant1?: string;
  surnameApplicant1?: string;
  emailApplicant1?: string;
  phone1?: string;
  consentGiven: boolean;
  gender1?: "" | "Male" | "Female";
  dateOfBirth1?: Date;

  mortgageType?: "" | "purchaser" | "switcher";
  applicationType?: "" | "joint" | "single";

  isFirstMortgage?: boolean;
  mortgageReason?: string;
  currentLender?: string;
  ber?: string;

  existingMortgage?: number;
  remainingTerm?: number;

  homeValue?: number;
  mortgageAmountRequired?: number;
  topup?: number;
  monthlyRepayments?: number;
  monthlySavings?: number;
  grossBasicIncome?: number;
  grossVariableIncome?: number;

  firstNameApplicant2?: string;
  surnameApplicant2?: string;
  emailApplicant2?: string;
  gender2?: "" | "Male" | "Female";
  dateOfBirth2?: Date;

  coverFor?: "" | "mortgage" | "mortgage / family";
  coverAmount?: number;
  coverTerm?: number;
  smoker?: string;
  partnerSmoker?: string;

  overpayBy?: number;
  monthsRemaining?: number;
  currentInterestRate?: number;

  referrer?: string;

  response?: string;
  currentStep: string;
  currentStepId?: string;
  gtmTag: string;

  leadId?: string;
  fastTrack?: boolean;
  bookedMeeting?: boolean;
  isCompleted?: boolean;

  portalLink?: string;
  existing?: boolean;
  // contact1?: IContact;
  // contact2?: IContact;

  leadCalculationResult?: ILeadCalculationResult;
  navigateToInvite?: boolean;

  lvhasdependent?: boolean;
  lvchildcarecost?: number;
  lvmaintenancecost?: number;
  lvEmploymentType?: string;
  lvhowlongtrading?: string;
  lvfulltimepermanent?: string;
  lvprobationpassed?: string;
  lvovertime?: number;
  lvshiftallowance?: number;
  lvbonus?: number;
  lvloanrepayment?: number;
  lvmonthlyrepayments?: number;
  //lvmonthlybalance?: number;
  lvtotalsavings?: number;
  lvretainexistingproperty?: string;
  lvequityfromsale?: number;
  lvpropertyvalue?: number;
  lvmortgageoutstanding?: number;
  lvtermremaining?: string;
  lvinterestrate?: number;
  lvmonthlyrent?: number;
  fixedRateExpiryDate?: string;
}

export interface IContact {
  id?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  portalFirstLogin?: any;
}

export interface ILeadCalculationResult {
  savings: number;
  repayment: number;
  cashback: number;
  term: number;
  rate: number;
  rateType: string;
  fixedYears: number;
  termString: string;
  response: string;
  nextStep: string;
}

export interface IRepaymentCalculationRequest {
  purchasePrice: number;
  mortgageAmount: number;
  term: number;
  ber?: string;
}

export interface ISwitcherCalculationRequest {
  purchasePrice: number;
  mortgageAmount: number;
  term: number;
  repayments: number;
  interestRate: number;
  ber: string;
}

export interface IOverpaymentCalculationRequest {
  mortgageAmount: number;
  term: number;
  repayments: number;
  interestRate: number;
  overpayBy: number;
}

export enum ProductCategory {
  Lowest = 0,
  Cashback = 1,
  Green = 2,
  Variable = 3,
  Fixed3 = 4,
  Fixed4 = 5,
  Fixed5 = 6,
}

export interface ILenderProduct {
  name: string;
  rate: number;
  minLTV: number;
  maxLTV: number;
  fixedYears: number;
  apr: number;
  type: string;
  minBer: number;
  minBerText: string;
  cashback: number;
  cashbackAmount: number;
  repayment: number;
  yearlySavings: number;
  category?: ProductCategory;
  lenderLogo?: string;
  lenderName?: string;
}

export interface ICalculationResult {
  currentRepayments: number;
  monthlySavings: number;
  yearlySavings: number;
  repayment: number;
  cashback: number;
  rate: number;
  rateType: string;
  fixedYears: number;
  monthsRemaining?: number;
  products: ILenderProduct[];
}
